import BoardContainer from '../board-container';

export default BoardContainer;
